export default `
query FetchSubscription{
    me {
        display_cart_entry
        subscription {
            id
            totes_left
            totes_left_tips
            on_hold
            hold_date
            promo_code
            status
            billing_date
            next_tote_status {
                message
                code
                final_code
                can_create_tote
            }
            subscription_type {
                id
                interval
                max_totes
                display_name_v2
                internal_name
                clothing_count
                accessory_count
                occasion
                base_price
                is_accessory_slot_giveaway
                auto_renew_price_per_month
                preview {
                    auto_renew_discount
                    cash_price
                    final_price
                    name
                    expiration_date_tips
                    promo_code_price
                  }
                free_service_type {
                    id
                    name
                    clothing_count
                    free_service_type_config {
                      popup_content {
                        img_url
                      }
                    }
                }
            }
        }
    }
}
`
